import React, { useRef } from 'react';
import './CBSEApplicationPrintView.css';
import Preloader from '../../../components/Preloader/Preloader';

const CBSEApplicationPrintView = ({ applicationData }) => {
  const contentRef = useRef(null);

  const handlePrint = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
    const styles = Array.from(document.styleSheets)
      .map(sheet => {
        try {
          return Array.from(sheet.cssRules)
            .map(rule => rule.cssText)
            .join('\n');
        } catch (e) {
          return '';
        }
      })
      .join('\n');
    
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <style>${styles}</style>
      </head>
      <body>
        ${contentRef.current.innerHTML}
      </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => {
      printWindow.print();
      printWindow.close();
    }, 250);
  };

  if (!applicationData) {
    return <div className="print-view-error">No application data available</div>;
  }

  const {
    jobPostingID,
    applicantName,
    applicationID,
    applicationStatus,
    appliedPost,
    appliedSubject,
    appliedSchoolID,
    schoolName,
    dateApplied,
    gender,
    emailID,
    phoneNumber,
    dateOfBirth,
    aadharNo,
    fatherName,
    motherName,
    spouseName,
    currentDesignationandDepartment,
    scoreInTETCTET,
    educationalQualification,
    expectedSalary,
    lastDrawnSalary,
    expectedDateofJoining,
    // Education Details
    pgDegree,
    pgUniversity,
    pgMedium,
    pgYearOfPassing,
    pgPercentage,
    ugDegree,
    ugUniversity,
    ugMedium,
    ugYearOfPassing,
    ugPercentage,
    class12School,
    class12Institute,
    class12Medium,
    class12YearOfPassing,
    class12Percentage,
    class10School,
    class10Institute,
    class10Medium,
    class10YearOfPassing,
    class10Percentage,
    // References
    reference1Name,
    reference1ContactNo,
    reference1Designation,
    reference2Name,
    reference2ContactNo,
    reference2Designation,
    // Work Experience
    workExperience,
    // Files
    files,
    // Additional Fields
    previousSchoolUANNO,
    previousSchoolESINo,
    pfNo,
  } = applicationData;

  return (
    <div className="print-view-wrapper">
      <div className="print-controls">
        <button onClick={handlePrint} className="btn-print-pdf">
          🖨️ Print
        </button>
      </div>

      <div ref={contentRef} className="print-container">
        {/* Header */}
        <div className="print-header">
          <div className="header-content">
            <h1>CBSE SCHOOL STAFF JOB APPLICATION FORM</h1>
            <p>Printable Version</p>
          </div>
          <div className="header-meta">
            <p>
              <strong>Application ID:</strong> {applicationID}
            </p>
            <p>
              <strong>Job Posting ID:</strong> {jobPostingID}
            </p>
          </div>
        </div>

        {/* Personal Information */}
        <div className="print-section">
          <h3 className="section-title">Personal Information</h3>
          <div className="section-content">
            <div className="info-row ">
              <div className="left-column">
                <div className="info-group">
                  <label>Full Name:</label>
                  <span>{applicantName}</span>
                </div>
                <div className="info-group">
                  <label>Email ID:</label>
                  <span>{emailID}</span>
                </div>
                <div className="info-group">
                  <label>Phone Number:</label>
                  <span>{phoneNumber}</span>
                </div>
              </div>
              <div className="info-group"></div>
              {files?.userPhoto && (
                <div className="info-group photo-group">
                 {/*} <label>Staff Photo:</label>*/}
                  <div className="photo-display-inline">
                    <img 
                      src={`https://s3.ap-south-1.amazonaws.com/images.mduschooled.in/staff/cbse/${appliedSchoolID}/${applicationID}/profile/${files.userPhoto}`} 
                      alt="Staff Photo" 
                      className="staff-photo"
                      onError={(e) => {
                        console.error('Error loading photo');
                        e.target.style.display = 'none';
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="info-row">
              <div className="info-group">
                <label>Date of Birth:</label>
                <span>{dateOfBirth}</span>
              </div>
              <div className="info-group">
                <label>Aadhar Number:</label>
                <span>{aadharNo}</span>
              </div>
              <div className="info-group">
                <label>Gender:</label>
                <span>{gender}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Position & School Details */}
        <div id='position applied' className="print-section">
          <h3 className="section-title">Position & School Details</h3>
          <div className="section-content">
            <div className="info-row">
              <div className="info-group">
                <label>Position Applied:</label>
                <span>{appliedPost}</span>
              </div>
              <div className="info-group">
                <label>Subject:</label>
                <span>{appliedSubject}</span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-group">
                <label>School Name:</label>
                <span>{schoolName || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Application Status */}
        <div id='application-status' className="print-section">
          <h3 className="section-title">Application Status</h3>
          <div className="section-content">
            <div className="info-row">
              <div className="info-group">
                <label>Status:</label>
                <span className={`status-badge status-${applicationStatus?.toLowerCase()}`}>
                  {applicationStatus}
                </span>
              </div>
              <div className="info-group">
                <label>Date Applied:</label>
                <span>{dateApplied}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Family Information */}
        <div className="print-section">
          <h3 className="section-title">Family Information</h3>
          <div className="section-content">
            <div className="info-row">
              <div className="info-group">
                <label>Father's Name:</label>
                <span>{fatherName}</span>
              </div>
              <div className="info-group">
                <label>Mother's Name:</label>
                <span>{motherName}</span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-group">
                <label>Spouse Name:</label>
                <span>{spouseName || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Education Details */}
        <div className="print-section">
          <h3 className="section-title">Educational Qualifications</h3>
          <div className="section-content">
            {/* Postgraduate */}
            <div className="education-subsection">
              <h4>Postgraduate (PG)</h4>
              <div className="info-row">
                <div className="info-group">
                  <label>Degree:</label>
                  <span>{pgDegree || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>University:</label>
                  <span>{pgUniversity || 'N/A'}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-group">
                  <label>Medium:</label>
                  <span>{pgMedium || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Year of Passing:</label>
                  <span>{pgYearOfPassing || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Percentage:</label>
                  <span>{pgPercentage || 'N/A'}</span>
                </div>
              </div>
            </div>

            {/* Undergraduate */}
            <div className="education-subsection">
              <h4>Undergraduate (UG)</h4>
              <div className="info-row">
                <div className="info-group">
                  <label>Degree:</label>
                  <span>{ugDegree || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>University:</label>
                  <span>{ugUniversity || 'N/A'}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-group">
                  <label>Medium:</label>
                  <span>{ugMedium || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Year of Passing:</label>
                  <span>{ugYearOfPassing || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Percentage:</label>
                  <span>{ugPercentage || 'N/A'}</span>
                </div>
              </div>
            </div>

            {/* 12th Standard */}
            <div className="education-subsection">
              <h4>12th Standard (Senior Secondary)</h4>
              <div className="info-row">
                <div className="info-group">
                  <label>School Name:</label>
                  <span>{class12School || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Institution:</label>
                  <span>{class12Institute || 'N/A'}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-group">
                  <label>Medium:</label>
                  <span>{class12Medium || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Year of Passing:</label>
                  <span>{class12YearOfPassing || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Percentage:</label>
                  <span>{class12Percentage || 'N/A'}</span>
                </div>
              </div>
            </div>

            {/* 10th Standard */}
            <div className="education-subsection">
              <h4>10th Standard (Secondary)</h4>
              <div className="info-row">
                <div className="info-group">
                  <label>School Name:</label>
                  <span>{class10School || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Institution:</label>
                  <span>{class10Institute || 'N/A'}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-group">
                  <label>Medium:</label>
                  <span>{class10Medium || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Year of Passing:</label>
                  <span>{class10YearOfPassing || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Percentage:</label>
                  <span>{class10Percentage || 'N/A'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Professional Qualifications */}
        <div className="print-section">
          <h3 className="section-title">Professional Qualifications</h3>
          <div className="section-content">
            <div className="info-row">
              <div className="info-group">
                <label>Educational Qualification:</label>
                <span>{educationalQualification}</span>
              </div>
              <div className="info-group">
                <label>TET/CTET Score:</label>
                <span>{scoreInTETCTET}</span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-group">
                <label>Current Designation & Department:</label>
                <span>{currentDesignationandDepartment}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Previous Employment Information */}
        <div className="print-section">
          <h3 className="section-title">Previous Employment Information</h3>
          <div className="section-content">
            <div className="info-row">
              <div className="info-group">
                <label>Previous School UAN No:</label>
                <span>{previousSchoolUANNO || 'N/A'}</span>
              </div>
              <div className="info-group">
                <label>Previous School ESI No:</label>
                <span>{previousSchoolESINo || 'N/A'}</span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-group">
                <label>PF No:</label>
                <span>{pfNo || 'N/A'}</span>
              </div>
              <div className="info-group">
                <label>Last Drawn Salary:</label>
                <span>{lastDrawnSalary || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Work Experience */}
        {workExperience && workExperience.length > 0 && (
          <div className="print-section">
            <h3 className="section-title">Work Experience</h3>
            <div className="section-content">
              {workExperience.map((exp, index) => (
                <div key={index} className="experience-item">
                  <h4>Experience #{index + 1}</h4>
                  <div className="info-row">
                    <div className="info-group">
                      <label>Institution Name:</label>
                      <span>{exp.institutionName || 'N/A'}</span>
                    </div>
                    <div className="info-group">
                      <label>Designation:</label>
                      <span>{exp.designation || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="info-row">
                    <div className="info-group">
                      <label>From:</label>
                      <span>{exp.fromDate || 'N/A'}</span>
                    </div>
                    <div className="info-group">
                      <label>To:</label>
                      <span>{exp.toDate || 'N/A'}</span>
                    </div>
                    <div className="info-group">
                      <label>Years:</label>
                      <span>{exp.years || 'N/A'}</span>
                    </div>
                  </div>
                  <div className="info-row">
                    <div className="info-group full-width">
                      <label>Reason For Leaving:</label>
                      <span>{exp.reasonForLeaving || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Salary Information */}
        <div className="print-section">
          <h3 className="section-title">Salary Information</h3>
          <div className="section-content">
            <div className="info-row">
              <div className="info-group">
                <label>Expected Salary:</label>
                <span>₹ {expectedSalary || 'N/A'}</span>
              </div>
              <div className="info-group">
                <label>Expected Date of Joining:</label>
                <span>{expectedDateofJoining}</span>
              </div>
            </div>
          </div>
        </div>

        {/* References */}
        <div className="print-section">
          <h3 className="section-title">Reference Details</h3>
          <div className="section-content">
            <div className="reference-item">
              <h4>Reference 1</h4>
              <div className="info-row">
                <div className="info-group">
                  <label>Name:</label>
                  <span>{reference1Name || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Contact Number:</label>
                  <span>{reference1ContactNo || 'N/A'}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-group">
                  <label>Designation:</label>
                  <span>{reference1Designation || 'N/A'}</span>
                </div>
              </div>
            </div>

            <div className="reference-item">
              <h4>Reference 2</h4>
              <div className="info-row">
                <div className="info-group">
                  <label>Name:</label>
                  <span>{reference2Name || 'N/A'}</span>
                </div>
                <div className="info-group">
                  <label>Contact Number:</label>
                  <span>{reference2ContactNo || 'N/A'}</span>
                </div>
              </div>
              <div className="info-row">
                <div className="info-group">
                  <label>Designation:</label>
                  <span>{reference2Designation || 'N/A'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Attachments */}
        {files && (
          <div id='attachment-section' className="print-section">
            <h3 className="section-title">Attachments</h3>
            <div className="section-content">
              <div className="attachments-grid">
                <div className="attachment-item">
                  <label>User Photo:</label>
                  <span>{files.userPhoto ? '✓ ' + files.userPhoto : 'Not Uploaded'}</span>
                </div>
                <div className="attachment-item">
                  <label>UG Certificate:</label>
                  <span>{files.ugCertificate ? '✓ ' + files.ugCertificate : 'Not Uploaded'}</span>
                </div>
                <div className="attachment-item">
                  <label>PG Certificate:</label>
                  <span>{files.pgCertificate ? '✓ ' + files.pgCertificate : 'Not Uploaded'}</span>
                </div>
                <div className="attachment-item">
                  <label>Aadhar Copy:</label>
                  <span>{files.aadharCopy ? '✓ ' + files.aadharCopy : 'Not Uploaded'}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <div className="print-footer">
          <p>
            This is an official application form for CBSE School Staff Job Position. For verification
            purposes only.
          </p>
          <p>
            Generated on: <strong>{new Date().toLocaleString()}</strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CBSEApplicationPrintView;
